<template>
    <div class="view-container">
      <modal :showDialog="selectedRow != null" @close="closeModal" :maxWidth="'50vw'" :title="selectedRow!= null ? questions.find(x => x.id == selectedRow.dataId).description : null">
        <div class="m-4">
          <div style="font-weight: bold;" class="mb-1">
             {{ selectedRow != null ? questions.find(x => x.id == selectedRow.dataId).description : null }}
          </div>
          <div style="white-space: pre-line;">
            {{ selectedRow != null ? questions.find(x => x.id == selectedRow.dataId).conditions : null }}
          </div>
        </div>
      </modal>
      <div v-if="saveError" class="faq-save-error" role="alert">{{ saveError }}</div>
      <div style="width: 100%; height: 100%; overflow-x: auto">
        <div class="max-grid">
          <ejs-grid ref="grid" height='100%' width='100%' :toolbar="toolbar" :rowSelected="rowSelected" :rowDeselected="rowDeselected" :selectionSettings='selectionOptions' :allowTextWrap="true" :textWrapSettings='wrapSettings' :dataBound='dataBound' :dataSource="questions" :allowPaging="false" :allowFiltering='false' :allowSorting='true' :allowMultiSorting='true' :showBusyIndicator="true" :allowGrouping='true' :groupSettings='groupOptions'>
            <e-columns>
              <e-column field='id' :isPrimaryKey="true" :headerText="$t('NUMBER')" textAlign='Left' :customAttributes="customAttributes" ></e-column>
              <e-column field='description' :headerText="$t('DESCRIPTION')" textAlign='Left' :customAttributes="customAttributes"></e-column>
              <e-column v-if="$store.getters.isAdmin" field="sendToMobile" :headerText="$t('SEND_TO_MOBILE')" :template="mobileTemplate" :allowFiltering="false" :allowSorting="false" textAlign="Center"></e-column>
              <e-column v-if="$store.getters.isAdmin" field="sendPush" :headerText="$t('SEND_PUSH')" :template="pushTemplate" :allowFiltering="false" :allowSorting="false" textAlign="Center"></e-column>
              <e-column :visible="false" field='priorityText' :headerText="$t('PRIORITY')" textAlign='Left' :customAttributes="customAttributes"></e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </div>
    </div>
</template>

<script>
import { Sort, Filter, Toolbar, Search, CommandColumn, Page } from '@syncfusion/ej2-vue-grids';
import Modal from '../components/Modal.vue';
import { getAllAlarmTypesFaq, updateSendToMobileStatus, updateSendPushStatus } from '@api'
import Vue from "vue";

export let context = null

// Komórka z checkboxem dla pola typu alarmu. Grid Syncfusion wstrzykuje wiersz jako `data`
// (kopię), więc stan zawsze czytamy i zmieniamy przez widok (context), a nie lokalnie.
// Klasa faq-checkbox pozwala rowSelected odróżnić klik w checkbox od kliku w wiersz.
function checkboxTemplate(name, field) {
  return function() {
    return {
      template: Vue.component(name, {
        template: `<label class="faq-checkbox" :title="hint" @click.stop>
            <input type="checkbox" :checked="data[field]" :disabled="disabled" @change="changed">
          </label>`,
        data: function() {
          return {
            data: {},
            field
          }
        },
        computed: {
          // Push prowadzi do listy alarmów w aplikacji, a ta pokazuje tylko typy z "send to mobile".
          disabled() {
            return field === 'sendPush' && !this.data.sendToMobile
          },
          hint() {
            return this.disabled ? context.$t('PushRequiresSendToMobile') : ''
          }
        },
        methods: {
          changed(event) {
            context.updateFlag(this.data.id, field, event.target.checked)
          }
        }
      })
    }
  }
}

export default {
    props: {},
    components: {
        Modal
    },
    provide: {
        grid: [ Sort, Page, Filter, Toolbar, Search, CommandColumn ]
    },
    data() {
        return {
            selectedRow: null,
            saveError: null,
            questions: [],
			      selectedQuestion: null,

            toolbar:[
                'Search'
            ],
            filterOptions: {
                type: 'Menu'
            },
            wrapSettings: { wrapMode: 'Content' } ,
            selectionOptions: { type: 'Single' },
            customAttributes : {class: 'customcss'},
            groupOptions: { columns: ['priorityText'] },
            mobileTemplate: checkboxTemplate('faqSendToMobileTemplate', 'sendToMobile'),
            pushTemplate: checkboxTemplate('faqSendPushTemplate', 'sendPush')
        }
    },
    methods: {
        async getData(){
            this.$store.dispatch('set_loading', true)
            this.questions = await getAllAlarmTypesFaq()
            this.questions.forEach(el => {
              el.description = this.$t(el.description)
            })
            this.questions.forEach(el => {
                el.priorityText = [this.$t('HIGH'), this.$t('MID'), this.$t('LOW')][el.priority - 1]
            })
            this.questions = this.questions.sort((a, b) => (a.priority - b.priority))
            this.$store.dispatch('set_loading', false)
        },
        // rowClick(index) {
        //     if(this.selectedRow !== index) {
        //         this.selectedRow = index;
        //     } else {
        //         this.selectedRow = null;
        //     }
        // },
        rowClass(index) {
            return this.selectedRow === index ? 'selected py-4' : ''
        },
        toolbarClick: function(args) {
            switch(args.item.id){

            }
        },
        dataBound: function() {
            this.$refs.grid.autoFitColumns();
        },
        rowSelected: function(row) {
          if (!row.target || !row.target.closest('.faq-checkbox')) {
            this.selectedRow = {rowindex: row.rowIndex, dataId: row.data.id};
          } else {
            this.$refs.grid.clearSelection();
          }
        },
        rowDeselected(row) {
            this.selectedRow = null
            // this.selectedRow = row.
        },
        closeModal() {
            this.selectedRow = null
            this.$refs.grid.clearSelection();
        },
        // Zmiana od razu w wierszu, a przy błędzie zapisu powrót do poprzedniego stanu.
        // Wyłączenie "send to mobile" wyłącza też push (tak samo robi API).
        async updateFlag(id, field, value) {
          const row = this.questions.find(x => x.id == id)
          const previous = { sendToMobile: row.sendToMobile, sendPush: row.sendPush }

          row[field] = value
          if (field === 'sendToMobile' && !value) row.sendPush = false
          this.refreshRow(row)

          try {
            if (field === 'sendToMobile') {
              await updateSendToMobileStatus(id, value)
            } else {
              await updateSendPushStatus(id, value)
            }
            this.saveError = null
          } catch (e) {
            Object.assign(row, previous)
            this.refreshRow(row)
            this.saveError = this.$t('AlarmTypeUpdateFailed')
          }
        },
        // Szablony komórek dostają kopię wiersza - bez tego checkbox push nie zauważyłby
        // wyłączenia "send to mobile" w sąsiedniej kolumnie.
        refreshRow(row) {
          this.$refs.grid.setRowData(row.id, { ...row })
        }
    },
    mounted: async function () {
    	this.getData();

      context = this;
    },
}
</script>

<style scoped>

.table {
    border-top: none;
    border-left: none;
    border-right: none;
}
.table tbody{
    border-left: 1px solid #A3D4E0;
    border-right: 1px solid #A3D4E0;
}
.e-grid .e-headercell.customcss{
    padding:0 5px 0 5px;
}
.e-grid .e-headercell .e-headercelldiv{
    padding-right:5px;
}
.e-gridchkbox.customcss .e-checkbox-wrapper{
    vertical-align: middle;
}

.faq-save-error {
    margin-bottom: 8px;
    padding: 8px 12px;
    border-radius: 8px;
    background-color: var(--danger-hover-bg);
    color: var(--danger);
}
</style>

<style>
/* Poza scoped: komórki gridu to osobne komponenty szablonów. */
.faq-checkbox {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 4px;
    cursor: pointer;
}

.faq-checkbox input {
    width: 18px;
    height: 18px;
    margin: 0;
    accent-color: var(--accent);
    cursor: pointer;
}

.faq-checkbox input:disabled {
    cursor: not-allowed;
    opacity: 0.45;
}
</style>



// WEBPACK FOOTER //
// src/views/Faq.vue